import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from 'components/ui/Button';
import { Icon } from '@iconify/react';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="w-full h-full flex flex-col justify-center items-center space-y-10 px-8">
      <div className="flex flex-col gap-10 justify-center items-center h-full">
        <img
          alt="logo"
          src="/library-logo.svg"
        />
        <Icon icon="mdi:magnify" width="150" />
        <span className="text-5xl font-semibold">
          404
        </span>
      </div>
      <div className="w-full pb-5">
        <Button onClick={() => navigate('/home')} color="primary" text={t('general.back_to_home')} />
      </div>
    </div>
  )
}

export default NotFoundPage;